import React from 'react';
import {render} from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './scripts/App';
import DataActions          from './scripts/flux/actions/DataActions.js';

class AppInitializer {
  run() {
    DataActions.getAllData((response)=>{
      render((
        <BrowserRouter>
          <App response={response} />
        </BrowserRouter>
      ), document.getElementById('root'));
    });
  }
}

new AppInitializer().run();



// WEBPACK FOOTER //
// ./src/index.js